module.exports = __webpack_public_path__ + "static/img/coupon.35e7cc15.png";